module.exports = __webpack_public_path__ + "assets/img/report_l2.31eac613.png";